import {
  WalletIcon,
  CalculatorIcon,
  SearchIcon,
  CompassIcon,
  MapIcon,
  TagIcon,
  UsersIcon,
  MessageSquareTextIcon,
  ClipboardCheckIcon,
  EyeOffIcon,
  MessageCircleIcon,
  FileTextIcon,
  MapPinIcon,
  CalendarDaysIcon,
  PackageIcon,
  UserPlusIcon,
  SmartphoneIcon,
} from "lucide-react";

export const pains = [
  {
    icon: WalletIcon,
    text: "Querés emprender, pero todas las ideas parecen necesitar una inversión enorme.",
  },
  {
    icon: CalculatorIcon,
    text: "No sabés cuánto cobrar por una limpieza y tenés miedo de perder plata.",
  },
  {
    icon: SearchIcon,
    text: "No sabés dónde encontrar personas que realmente necesiten tus servicios.",
  },
  {
    icon: CompassIcon,
    text: "Te gustaría trabajar por tu cuenta, pero te falta un plan claro para empezar.",
  },
];

export const audience = [
  "Querés empezar a generar ingresos ofreciendo servicios de limpieza.",
  "Estás cansada de depender de un sueldo y querés construir algo propio.",
  "Tenés ganas de emprender, pero no sabés cómo conseguir tus primeros clientes.",
  "Ya hacés limpiezas, pero querés cobrar mejor y trabajar de forma más organizada.",
  "Soñás con pasar de trabajar sola a tener tu propio equipo.",
];

export const learnings = [
  "Definir qué servicios ofrecer y cómo organizarlos.",
  "Calcular precios teniendo en cuenta tus costos.",
  "Buscar clientes utilizando WhatsApp, redes sociales y contactos.",
  "Preparar presupuestos y comunicarte profesionalmente.",
  "Organizar tus tareas y planificar el crecimiento de tu negocio.",
];

export const benefits = [
  {
    icon: MapIcon,
    title: "Una hoja de ruta para empezar desde cero",
    text: "Sabés qué hacer primero, qué después y cómo avanzar sin improvisar.",
  },
  {
    icon: TagIcon,
    title: "Precios con criterio",
    text: "Aprendé a calcular cuánto cobrar sin elegir precios al azar.",
  },
  {
    icon: SearchIcon,
    title: "Tus primeros clientes",
    text: "Sabé dónde buscarlos y cómo dar a conocer tus servicios.",
  },
  {
    icon: MessageSquareTextIcon,
    title: "Mensajes y presupuestos",
    text: "Usá modelos de mensajes y presupuestos como referencia.",
  },
  {
    icon: ClipboardCheckIcon,
    title: "Checklists profesionales",
    text: "Organizá tus servicios y revisá cada trabajo con un método.",
  },
  {
    icon: EyeOffIcon,
    title: "Promoción sin mostrar tu cara",
    text: "Promocionate en redes sociales aunque no quieras aparecer en cámara.",
  },
  {
    icon: UsersIcon,
    title: "De sola a coordinar un equipo",
    text: "Entendé cómo dar el paso de trabajar sola a liderar personal.",
  },
];

export const modules = [
  "Cómo empezar tu negocio de limpieza",
  "Inversión inicial, productos y herramientas",
  "Costos, tarifas y presupuestos",
  "Cómo conseguir y atender clientes",
  "Organización de servicios y calidad del trabajo",
  "Promoción y contenido para redes sociales",
  "Administración, ganancias y crecimiento",
  "Cómo empezar a delegar y construir un equipo",
];

export const bonuses = [
  {
    number: "Bono 1",
    title: "Tus primeros clientes",
    text: "Mensajes y estrategias para empezar a contactar potenciales clientes por WhatsApp, Facebook e Instagram.",
    icon: MessageCircleIcon,
    tone: "mint",
  },
  {
    number: "Bono 2",
    title: "Guía de precios + Calculadora de Ganancias",
    text: "Fórmulas, ejemplos y plantillas para calcular tus precios y ganancias manualmente.",
    icon: CalculatorIcon,
    tone: "sun",
  },
  {
    number: "Bono 3",
    title: "Checklist Profesional de Limpieza",
    text: "Listas de control para organizar tareas, revisar resultados y trabajar con un método.",
    icon: ClipboardCheckIcon,
    tone: "ink",
  },
  {
    number: "Bono 4",
    title: "Pack de Documentos",
    text: "23 modelos de documentos para consultar, imprimir o completar manualmente.",
    icon: FileTextIcon,
    tone: "mint",
  },
  {
    number: "Bono 5",
    title: "Dónde encontrar clientes",
    text: "20 canales y estrategias para identificar oportunidades y dar a conocer tus servicios.",
    icon: MapPinIcon,
    tone: "sun",
  },
  {
    number: "Bono 6",
    title: "30 días de contenido",
    text: "Ideas, textos y propuestas de publicaciones para promocionar tu negocio, incluso sin aparecer en cámara.",
    icon: CalendarDaysIcon,
    tone: "ink",
  },
  {
    number: "Bono 7",
    title: "Starter Kit de Limpieza",
    text: "Guía de productos, herramientas y compras para organizar tu equipo inicial.",
    icon: PackageIcon,
    tone: "mint",
  },
  {
    number: "Bono 8",
    title: "De trabajar sola a tener un equipo",
    text: "Una guía para entender cómo seleccionar, organizar y capacitar personal cuando llegue el momento de crecer.",
    icon: UserPlusIcon,
    tone: "sun",
  },
];

export const extraGift = {
  number: "Regalo extra",
  title: "Tu kit en el celular",
  text: "Un PDF de consulta rápida con 27 atajos de WhatsApp, mensajes, presupuestos, checklists y herramientas para organizar tu trabajo.",
  icon: SmartphoneIcon,
  tone: "ink",
};

export const testimonials = [
  {
    quote:
      "[Reseña auténtica de una compradora. Reemplazá este texto por un testimonio verificado.]",
    name: "[Nombre]",
    detail: "[Ciudad · Servicio que ofrece]",
  },
  {
    quote:
      "[Reseña auténtica de una compradora. Reemplazá este texto por un testimonio verificado.]",
    name: "[Nombre]",
    detail: "[Ciudad · Servicio que ofrece]",
  },
  {
    quote:
      "[Reseña auténtica de una compradora. Reemplazá este texto por un testimonio verificado.]",
    name: "[Nombre]",
    detail: "[Ciudad · Servicio que ofrece]",
  },
];

export const faqs = [
  {
    q: "¿Qué incluye el paquete?",
    a: "El ebook principal De cero a tu empresa de limpieza (189 páginas organizadas en 13 módulos), los 8 bonos exclusivos y el Kit en el celular. En total son 10 archivos PDF.",
  },
  {
    q: "¿Cómo recibo el ebook y los bonos?",
    a: "Después de que se confirme tu pago, vas a recibir acceso a los archivos digitales mediante el sistema de descargas de la tienda.",
  },
  {
    q: "¿Puedo acceder desde mi celular?",
    a: "Sí. Los PDF se pueden consultar desde un celular, una computadora o una tablet compatible.",
  },
  {
    q: "¿Necesito experiencia previa para comenzar?",
    a: "No. La guía está pensada para personas que quieren empezar desde cero y también para quienes ya ofrecen servicios de limpieza y desean organizarse mejor.",
  },
  {
    q: "¿Qué necesito para empezar mi negocio de limpieza?",
    a: "Para empezar a aprender, solo necesitás el material y tiempo para leerlo. Para empezar a ofrecer servicios, el módulo de inversión inicial y el Bono 7 (Starter Kit de Limpieza) te orientan sobre qué productos y herramientas conseguir, y no hace falta tener empleados: el contenido contempla cómo empezar trabajando por tu cuenta.",
  },
  {
    q: "¿Los documentos son editables?",
    a: "No se incluyen archivos Word ni Excel editables. Las guías contienen modelos, fórmulas y plantillas que podés consultar, imprimir o utilizar como referencia para crear tus propios documentos.",
  },
  {
    q: "¿Sirve si vivo fuera de Argentina?",
    a: "Sí. El contenido utiliza principalmente ejemplos en pesos argentinos y también incluye referencias para adaptar los cálculos a otros países.",
  },
  {
    q: "¿Voy a conseguir clientes automáticamente?",
    a: "No. La guía te enseña estrategias y herramientas para buscar clientes, pero los resultados dependen de cómo las apliques, tu mercado y tu constancia.",
  },
  {
    q: "¿Tiene garantía?",
    a: "Consultá las condiciones de compra, cancelación y reembolso informadas en nuestra tienda antes de finalizar tu pedido.",
  },
];
